// ==========================================================================
// SANITIZE & ESCAPING UTILITIES FOR WURUPAYROLL
// Protects against XSS, broken HTML attributes, and inline string breaks
// ==========================================================================

/**
 * Escapes characters for safe inclusion in HTML body and attribute values.
 * Replaces &, <, >, ", and ' with safe HTML entities.
 * @param {any} str - Input value to sanitize
 * @returns {string} Sanitized string
 */
export function escapeHtml(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Alias for escapeHtml to be explicitly used in HTML attribute values (value="...")
 * @param {any} str - Input attribute value
 * @returns {string} Sanitized string
 */
export function escapeAttr(str) {
  return escapeHtml(str);
}

/**
 * Escapes a string for safe embedding into inline JavaScript string parameters
 * (e.g. onclick="someFunc('PARAM')") to prevent quotes from breaking syntax or injection.
 * @param {any} str - Parameter string
 * @returns {string} Escaped parameter string
 */
export function escapeJsParam(str) {
  if (str === null || str === undefined) return '';
  return String(str)
    .replace(/\\/g, '\\\\')
    .replace(/'/g, "\\'")
    .replace(/"/g, '&quot;')
    .replace(/</g, '\\x3c')
    .replace(/>/g, '\\x3e')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '\\r');
}

// Bind to window for global inline accessibility
if (typeof window !== 'undefined') {
  window.escapeHtml = escapeHtml;
  window.escapeAttr = escapeAttr;
  window.escapeJsParam = escapeJsParam;
}
